import { createFileRoute } from "@tanstack/react-router";
import Features from "@/pages/Features";
import { pageHead } from "@/lib/seo";
import { featuresBreadcrumb, featuresFaqSchema } from "@/utils/schema";

export const Route = createFileRoute("/zh/features")({
  head: () => ({
    ...pageHead("/features", "zh"),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(featuresBreadcrumb("zh")),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(featuresFaqSchema("zh")),
      },
    ],
  }),
  component: Features,
});
